import React from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';

export const FulfillmentPodPlaceholder = () => (
  <div data-component="FulfillmentPodPlaceholder">
    <Placeholder type="text" />
    <Placeholder type="text" />
  </div>
);
